<template>
    <div class="application-form container">
        <!-- Company Selection Screen -->
        <div v-if="!selectedCompany" class="select-company">
            <h1>Select the Company your applying to.</h1>
            <div class="company-logos">
               
                 <div class="company-card" @click="() => selectCompany('RTH Construction')">
                    <img src="@/assets/rth_construction1.png" alt="RTH Construction Logo" />
                    <p>RTH Construction</p>
                </div>
                
                <div class="company-card" @click="() => selectCompany('RTH Cleaners')">
                    <img src="@/assets/R.T.H%20Logo%20Image.png" alt="RTH Cleaners Logo" />
                    <p>RTH Cleaners</p>
                </div>
                <div class="company-card" @click="() => selectCompany('RTH Group')">
                    <img src="@/assets/RTH%20Group%20Logo%20Image.png" alt="RTH Group Logo" />
                    <p>RTH Group</p>
                </div>

            </div>
        </div>

        <!-- Application Form Screen -->
        <div v-else>
            <h1>Job Application - {{ selectedCompany }}</h1>

            <div class="back-to-selection">
                <button type="button" class="btn-back" @click="resetCompany">← Back to Company Selection</button>
            </div>

            <div class="progress-container">
                <div class="progress-bar" :style="{ width: (currentStep / 7 * 100) + '%' }"></div>
            </div>

            <div class="step-indicator">
                <div v-for="n in 7" :key="n" :class="{ active: currentStep === n, completed: currentStep > n }">{{ n }}
                </div>
            </div>

            <div v-if="showConfirmModal" class="modal-overlay">
                <div class="modal-content">
                    <h2>Are you sure?</h2>
                    <p>You will lose any unsaved information if you go back to company selection.</p>
                    <div class="modal-actions">
                        <button class="btn-cancel" @click="cancelReset">Cancel</button>
                        <button class="btn-confirm" @click="confirmReset">Yes, Go Back</button>
                    </div>
                </div>
            </div>

            <form @submit.prevent="handleSubmit">
                <div v-if="currentStep === 1" class="form-step">
                    <h2 class="text-lg font-semibold mb-4">Personal Information</h2>

                    <!-- Position Applying For -->
                    <div class="mb-4">
                        <label class="block text-sm font-medium text-gray-700 mb-1">Position Applying For</label>
                        <select v-model="form.positionapplying" class="form-select w-full border rounded px-3 py-2">
                            <option disabled value="">Select Position</option>
                            <option value="Front Desk">Front Desk</option>
                            <option value="Maintenance">Maintenance</option>
                            <option value="Housekeeping">Housekeeping</option>
                            <option value="Park Attendant">Park Attendant</option>
                            <option value="Server">Server</option>
                            <option value="Dish Washer">Dish Washer</option>
                            <option value="Bar Tender">Bar Tender</option>
                            <option value="Houseman">Houseman</option>
                            <option value="Cook">Cook</option>
                            <option value="Other">Other</option>
                        </select>

                        <!-- Other Input -->
                        <transition name="fade">
                            <div v-if="form.positionapplying === 'Other'" class="mt-2">
                                <label class="block text-sm font-medium text-gray-700 mb-1">Please Specify</label>
                                <input v-model="form.otherPosition" type="text" class="w-full border rounded px-3 py-2"
                                    placeholder="Enter custom position" />
                            </div>
                        </transition>
                    </div>

                    <!-- Name Fields -->
                    <div class="form-row grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
                        <div>
                            <label>First Name</label>
                            <input v-model="form.firstName" type="text" class="w-full border rounded px-3 py-2" />
                        </div>
                        <div>
                            <label>Middle Name (optional)</label>
                            <input v-model="form.middleName" type="text" class="w-full border rounded px-3 py-2" />
                        </div>
                        <div>
                            <label>Last Name</label>
                            <input v-model="form.lastName" type="text" class="w-full border rounded px-3 py-2" />
                        </div>
                        <div>
                            <label>Date of Birth</label>
                            <input v-model="form.dateOfBirth" type="date" class="w-full border rounded px-3 py-2" />
                        </div>
                    </div>

                    <!-- Address -->
                    <div class="mb-4">
                        <label>Current Address</label>
                        <input v-model="form.address" type="text" class="w-full border rounded px-3 py-2" />
                    </div>

                    <!-- City / State / Zip -->
                    <div class="form-row grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
                        <div>
                            <label>City / Post Office</label>
                            <input v-model="form.city" type="text" class="w-full border rounded px-3 py-2" />
                        </div>
                        <div>
                            <label>State / Parish</label>
                            <input v-model="form.state" type="text" class="w-full border rounded px-3 py-2" />
                        </div>
                        <div>
                            <label>Zip Code</label>
                            <input v-model="form.zip" type="text" class="w-full border rounded px-3 py-2" />
                        </div>
                    </div>

                    <!-- Phone Numbers -->
                    <div class="form-row grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                        <div>
                            <label for="country" class="block mb-1 font-medium">Country</label>
                            <select id="country" v-model="form.country" class="w-full border rounded px-3 py-2">
                                <option disabled value="">Select a country</option>
                                <option>United States</option>
                                <option>Canada</option>
                                <option>Jamaica</option>
                                <option>Costa Rica</option>
                                <option>Columbia</option>
                                <option>Honduras</option>
                                <option>Ecuador</option>
                                <option>Guatemala</option>
                                <option>El Salvador</option>
                                <option>Haiti</option>
                                <option>Brazil</option>
                                <option>Dominican Republic</option>
                                <option>Mexico</option>
                            </select>
                        </div>

                        <div>
                            <label>Cell Number</label>
                            <input v-model="form.cell" type="tel" class="w-full border rounded px-3 py-2" />
                        </div>

                    </div>

                    <!-- Email / SSN -->
                    <div class="form-row grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                        <div>
                            <label>Email Address</label>
                            <input v-model="form.email" type="email" required class="w-full border rounded px-3 py-2" />
                        </div>
                        <div>
                            <label for="ssn" class="block mb-1 font-medium">Social Security Number</label>
                            <div class="ssn-wrapper">
                                <input id="ssn" v-model="form.ssn" v-mask="'###-##-####'"
                                    :type="showSSN ? 'text' : 'password'" autocomplete="off"
                                    pattern="^\d{3}-\d{2}-\d{4}$" required class="ssn-input"
                                    placeholder="123-45-6789" />

                                <button type="button" @click="showSSN = !showSSN" class="ssn-toggle"
                                    aria-label="Toggle SSN visibility">
                                    {{ showSSN ? 'Hide' : 'Show' }}
                                </button>
                            </div>
                        </div>
                    </div>

                    <!-- Emergency Contact -->
                    <div class="form-row grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                        <div>
                            <label>Emergency Contact Name</label>
                            <input v-model="form.emergencyContactName" type="text"
                                class="w-full border rounded px-3 py-2" />
                        </div>
                        <div>
                            <label>Emergency Contact Phone</label>
                            <input v-model="form.emergencyContactPhone" type="tel"
                                class="w-full border rounded px-3 py-2" />
                        </div>
                    </div>

                    <!-- Passport Fields -->
                    <div class="form-row grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                        <div>
                            <label>Passport Number</label>
                            <input v-model="form.passportnum" type="text" class="w-full border rounded px-3 py-2" />
                        </div>
                        <div>
                            <label>
                                📅 Passport Expiry Date
                            </label>
                            <input v-model="form.passportexpirationdate" type="date"
                                class="w-full border rounded px-3 py-2" />
                        </div>
                    </div>
                </div>


                <div class="form-step" v-if="currentStep === 2">
                    <h2>General Questions</h2>
                    <label>Have you ever been convicted of a felony?</label>
                    <select v-model="form.felony">
                        <option value="">Select...</option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                    </select>

                    <label>Willing to take a drug screening test?</label>
                    <select v-model="form.drugTest">
                        <option value="">Select...</option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                    </select>

                    <label>Willing to work on weekends?</label>
                    <select v-model="form.weekendWork">
                        <option value="">Select...</option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                    </select>
                </div>

                <div class="form-step" v-if="currentStep === 3">
                    <h2>Education</h2>
                    <p class="section-description">Please list schools attended, starting with the most recent (up to 3
                        entries).</p>

                    <div class="education-section-content">
                        <div class="education-table-container">
                            <table class="education-table">
                                <thead>
                                    <tr>
                                        <th>School Name</th>
                                        <th>Location (City, State)</th>
                                        <th>Years Attended</th>
                                        <th>Degree/Diploma</th>
                                        <th>Major/Field of Study</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(edu, index) in form.education" :key="index" class="education-entry-row">
                                        <td>
                                            <input v-model="edu.schoolName" type="text"
                                                :placeholder="index === 0 ? 'e.g., University Name' : ''"
                                                :aria-label="`School Name ${index + 1}`" />
                                        </td>
                                        <td>
                                            <input v-model="edu.schoolLocation" type="text"
                                                :placeholder="index === 0 ? 'e.g., City, ST' : ''"
                                                :aria-label="`School Location ${index + 1}`" />
                                        </td>
                                        <td>
                                            <input v-model="edu.yearsAttended" type="text"
                                                placeholder="e.g., 2020-2024 or 3"
                                                :aria-label="`Years Attended ${index + 1}`" />
                                        </td>
                                        <td>
                                            <input v-model="edu.degreeReceived" type="text"
                                                :placeholder="index === 0 ? 'e.g., B.S., Diploma' : ''"
                                                :aria-label="`Degree Received ${index + 1}`" />
                                        </td>
                                        <td>
                                            <input v-model="edu.major" type="text"
                                                :placeholder="index === 0 ? 'e.g., Computer Science' : ''"
                                                :aria-label="`Major ${index + 1}`" />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div class="education-actions">
                            <button type="button" class="icon-btn btn-add-edu" @click="addEducation"
                                :disabled="form.education.length >= 3" title="Add another education entry">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                    class="bi bi-plus-circle-fill" viewBox="0 0 16 16">
                                    <path
                                        d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.5 4.5a.5.5 0 0 0-1 0v3h-3a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3v-3z" />
                                </svg>
                                Add Education
                            </button>
                            <button type="button" class="icon-btn btn-remove-edu" @click="removeEducation"
                                :disabled="form.education.length <= 1" title="Remove the last education entry">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                    class="bi bi-trash3-fill" viewBox="0 0 16 16">
                                    <path
                                        d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5Zm-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5ZM4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06Zm6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528ZM8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5Z" />
                                </svg>
                                Remove Last
                            </button>
                        </div>
                    </div>

                    <div class="entry-divider"></div>
                    <h2>Other Training</h2>
                    <textarea v-model="form.certifications"
                        placeholder="List any other relevant training, certifications, or licenses held."
                        class="training-textarea" aria-label="Other training, certifications, or licenses">
                     </textarea>
                </div>
                <div class="form-step" v-if="currentStep === 4">
                    <h2 class="text-lg font-semibold text-purple-800 mb-4">Employment History</h2>

                    <!-- Employer Name & Work Phone -->
                    <div class="grid grid-cols-2 gap-4 mb-4">
                        <div>
                            <label class="block text-sm font-medium text-gray-700 mb-1">Employer Name</label>
                            <input v-model="form.employerName" type="text" class="w-full border rounded px-3 py-2" />
                        </div>
                        <div>
                            <label class="block text-sm font-medium text-gray-700 mb-1">Work Phone</label>
                            <input v-model="form.workPhone" type="tel" class="w-full border rounded px-3 py-2" />
                        </div>
                    </div>

                    <!-- Employment Dates -->
                    <div class="grid grid-cols-2 gap-4 mb-4">
                        <div>
                            <label class="block text-sm font-medium text-gray-700 mb-1">Start Date</label>
                            <input v-model="form.dateEmployed" type="date" class="w-full border rounded px-3 py-2" />
                        </div>
                        <div>
                            <label class="block text-sm font-medium text-gray-700 mb-1">End Date</label>
                            <input v-model="form.dateUnemployed" type="date" class="w-full border rounded px-3 py-2" />
                        </div>
                    </div>

                    <!-- Employer Address (Full Width) -->
                    <div class="mb-4">
                        <label class="block text-sm font-medium text-gray-700 mb-1">Employer Address</label>
                        <input v-model="form.employerAddress" type="text" class="w-full border rounded px-3 py-2" />
                    </div>

                    <!-- City / State / Zip -->
                    <div class="grid grid-cols-3 gap-4 mb-4">
                        <div>
                            <label class="block text-sm font-medium text-gray-700 mb-1">City / Post Office</label>
                            <input v-model="form.employerCity" type="text" class="w-full border rounded px-3 py-2" />
                        </div>
                        <div>
                            <label class="block text-sm font-medium text-gray-700 mb-1">State / Parish</label>
                            <input v-model="form.employerState" type="text" class="w-full border rounded px-3 py-2" />
                        </div>
                        <div>
                            <label class="block text-sm font-medium text-gray-700 mb-1">Zip Code</label>
                            <input v-model="form.employerZip" type="text" class="w-full border rounded px-3 py-2" />
                        </div>
                    </div>

                    <!-- Position & Supervisor -->
                    <div class="grid grid-cols-2 gap-4 mb-4">
                        <div>
                            <label class="block text-sm font-medium text-gray-700 mb-1">Position Held</label>
                            <input v-model="form.positionHeld" type="text" class="w-full border rounded px-3 py-2" />
                        </div>
                        <div>
                            <label class="block text-sm font-medium text-gray-700 mb-1">Supervisor’s Name &
                                Title</label>
                            <input v-model="form.supervisorName" type="text" class="w-full border rounded px-3 py-2" />
                        </div>
                    </div>

                    <!-- Duties & Reason for Leaving -->
                    <div class="grid grid-cols-2 gap-4 mb-4">
                        <div>
                            <label class="block text-sm font-medium text-gray-700 mb-1">Duties Performed</label>
                            <textarea v-model="form.dutiesPerformed" rows="3"
                                class="w-full border rounded px-3 py-2"></textarea>
                        </div>
                        <div>
                            <label class="block text-sm font-medium text-gray-700 mb-1">Reason for Leaving</label>
                            <textarea v-model="form.reasonForLeaving" rows="3"
                                class="w-full border rounded px-3 py-2"></textarea>
                        </div>
                    </div>

                    <!-- May We Contact -->
                    <div class="grid grid-cols-2 gap-4 mb-4">
                        <div>
                            <label class="block text-sm font-medium text-gray-700 mb-1">May we contact your previous
                                employer?</label>
                            <select v-model="form.mayContactEmployer"
                                class="form-select w-full border rounded px-3 py-2">
                                <option value="">Select...</option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                            </select>
                        </div>
                    </div>
                </div>

                <div class="form-step" v-if="currentStep === 5">
                    <h2>References</h2>
                    <div v-for="n in 3" :key="n" class="reference-group">
                        <input v-model="form[`reference${n}Name`]" type="text" :placeholder="`Reference ${n} - Name`" />
                        <input v-model="form[`reference${n}Title`]" type="text"
                            :placeholder="`Reference ${n} - Title`" />
                        <input v-model="form[`reference${n}Company`]" type="text"
                            :placeholder="`Reference ${n} - Company`" />
                        <input v-model="form[`reference${n}Phone`]" type="tel"
                            :placeholder="`Reference ${n} - Phone`" />
                    </div>
                </div>

                <div class="form-step" v-if="currentStep === 6">
                    <h2>Upload Documents</h2>

                    <!-- Passport Upload -->
                    <div class="file-upload">
                        <label for="passport" class="file-upload-label">
                            📂 Upload Photo (Not a Photo of your passport)<br>(JPEG, JPG, GIF, PNG)
                            <span v-if="loadingFile" class="loading-spinner">⏳ Processing...</span>
                        </label>
                        <input type="file" id="passport" class="file-input" @change="validatePassport($event)"
                            accept=".jpeg,.jpg,.gif,.png" />
                        <p v-if="form.passport && !loadingFile" class="file-name">{{ form.passport.name }}</p>
                        <p v-if="passportError" class="error-text">{{ passportError }}</p>

                        <div v-if="showProcessing" class="upload-overlay local">
                            <div class="spinner"></div>
                            <p>Validating image…</p>
                        </div>
                    </div>

                    <!-- Resume Upload -->
                    <div class="file-upload">
                        <label for="resume" class="file-upload-label">📂 Resume (please upload PDF file)</label>
                        <input type="file" id="resume" class="file-input" @change="handleFileUpload($event, 'resume')"
                            accept=".pdf,.doc" />
                        <p v-if="form.resume" class="file-name">{{ form.resume.name }}</p>
                    </div>

                    <!-- Reference Recommendation Letter 1 -->
                    <div class="file-upload">
                        <label for="reference1" class="file-upload-label">📂 Reference Recommendation Letter 1</label>
                        <input type="file" id="reference1" class="file-input"
                            @change="handleFileUpload($event, 'reference1')" accept=".pdf,.doc,.docx" />
                        <p v-if="form.reference1" class="file-name">{{ form.reference1.name }}</p>
                    </div>

                    <!-- Reference Recommendation Letter 2 -->
                    <div class="file-upload">
                        <label for="reference2" class="file-upload-label">📂 Reference Recommendation Letter 2</label>
                        <input type="file" id="reference2" class="file-input"
                            @change="handleFileUpload($event, 'reference2')" accept=".pdf,.doc,.docx" />
                        <p v-if="form.reference2" class="file-name">{{ form.reference2.name }}</p>
                    </div>
                </div>

                <div class="form-step" v-if="currentStep === 7">
                    <h2>Acknowledgement and Authorization</h2>

                    <div class="checkbox-group">
                        <label class="checkbox-item">
                            <input type="checkbox" v-model="form.certifyTruth" />
                            <span>I certify that all answers given are true and complete to the best of my
                                knowledge.</span>
                        </label>

                        <label class="checkbox-item">
                            <input type="checkbox" v-model="form.authorizeInvestigation" />
                            <span>I authorize investigation of all statements contained in this application for
                                employment
                                as may be necessary in arriving at an employment decision.</span>
                        </label>

                        <label class="checkbox-item">
                            <input type="checkbox" v-model="form.understandConsequence" />
                            <span>In the event of employment, I understand that false or misleading information given in
                                my application or interview(s) may result in discharge.</span>
                        </label>
                    </div>



                    <div class="signature-wrapper">
                        <label>Draw Your Signature:</label>
                        <canvas ref="signatureCanvas" class="signature-canvas"></canvas>
                        <div class="signature-buttons">
                            <button type="button" class="btn-clear" @click="clearSignature">Clear</button>
                        </div>
                    </div>

                    <div class="signature-date">
                        <label>Application Date:</label>
                        <input v-model="form.applicationDate" type="date" />
                    </div>
                </div>

                <div class="form-navigation">
                    <button type="button" @click="prevStep" v-if="currentStep > 1">Back</button>
                    <button type="button" @click="nextStep" v-if="currentStep < 7">Next</button>
                    <button type="submit" v-if="currentStep === 7" @click.prevent="handleSubmit" :disabled="loading">
                        {{ loading ? 'Submitting...' : 'Submit' }}
                    </button>
                </div>
            </form>
        </div>
    </div>
</template>

<script setup>
import { notifyWarning, notifyError } from '@/services/notify'
import { useRouter } from 'vue-router'
import { ref, reactive, watch, nextTick } from 'vue'
import SignaturePad from 'signature_pad'
import { db, storage } from '@/firebase'  // Fix: import the storage instance
import { collection, addDoc, serverTimestamp } from 'firebase/firestore'
import { ref as storageRef, uploadBytes, getDownloadURL } from "firebase/storage";
import Swal from 'sweetalert2'

const router = useRouter()
// Step management
const selectedCompany = ref(null)
const currentStep = ref(1)
const showConfirmModal = ref(false)

// Signature pad
const signatureCanvas = ref(null)
let signaturePad = null
const passportError = ref(null);
const loadingFile = ref(false);
const showProcessing = ref(false);

const showSSN = ref(false)
const emailInput = ref(null)
watch(currentStep, async (newStep) => {
    if (newStep === 7) {
        await nextTick()
        if (signatureCanvas.value) {
            signaturePad = new SignaturePad(signatureCanvas.value)
        }
    }
})

const clearSignature = () => {
    if (signaturePad) signaturePad.clear()
}


// Navigation
const selectCompany = (company) => {
    selectedCompany.value = company
    currentStep.value = 1
    showConfirmModal.value = false
    window.scrollTo({ top: 0, behavior: 'smooth' })
}

const nextStep = async () => {

    if (currentStep.value === 1 && !form.email) {
        await Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Please enter your email address.',
        })
        // wait for the DOM update, then focus
        await nextTick()
        emailInput.value?.focus()
        return

    }
    if (currentStep.value === 1) {
        if (isvalidEmail(form.email) === false) {
            return Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Please enter a valid email address.',
            })
        }
    }
    if (currentStep.value === 1 && !form.country) {
        return Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Please select a country.',
        })
    }
    if (currentStep.value === 1 && !form.dateOfBirth) {
        return Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Please enter your date of birth.',
        })
    }


    if (currentStep.value < 7) {
        currentStep.value++
        window.scrollTo({ top: 0, behavior: 'smooth' })
    }
}

function isvalidEmail(email) {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
}

function prevStep() {
    if (currentStep.value > 1) {
        currentStep.value--
    }
}

const resetCompany = () => {
    showConfirmModal.value = true
}

const confirmReset = () => {
    selectedCompany.value = null
    currentStep.value = 1
    showConfirmModal.value = false
    window.scrollTo({ top: 0, behavior: 'smooth' })
}

const cancelReset = () => {
    showConfirmModal.value = false
}
async function validatePassport(event) {
    passportError.value = null;
    const file = event.target.files[0];

    if (!file) {
        passportError.value = 'Please select a file.';
        return;
    }

    // Start processing overlay
    showProcessing.value = true;
    loadingFile.value = true;
    await nextTick();

    const validTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif'];
    if (!validTypes.includes(file.type)) {
        passportError.value = 'Invalid file type. Only JPEG, JPG, PNG, and GIF are allowed.';
        loadingFile.value = false;
        showProcessing.value = false;
        return;
    }

    const image = new Image();
    image.onload = () => {
        form.passport = file;
        passportError.value = null;
        loadingFile.value = false;
        showProcessing.value = false;
    };
    image.onerror = () => {
        passportError.value = 'Invalid image file.';
        loadingFile.value = false;
        showProcessing.value = false;
    };
    image.src = URL.createObjectURL(file);
}


function handleFileUpload(event, fieldName) {
    const file = event.target.files[0];
    if (file) {
        form[fieldName] = file;
    }
}

// Form data
const form = reactive({
    positionapplying: '',
    otherPosition: '',
    position: '',
    firstName: '',
    middleName: '',
    dateOfBirth: '',
    lastName: '',
    address: '',
    city: '',
    state: '',
    zip: '',
    cell: '',
    whatsapp: '',
    email: '',
    ssn: '',
    emergencyContactName: '',
    emergencyContactPhone: '',
    education: [
        { schoolName: '', schoolLocation: '', yearsAttended: '', degreeReceived: '', major: '' }
    ],
    applicationDate: '',
    applicantSignatureDataUrl: '',
    passport: null,
    resume: null,
    reference1: null,
    reference2: null
})

function addEducation() {
    if (form.education.length < 3) {
        form.education.push({
            schoolName: '',
            schoolLocation: '',
            yearsAttended: '',
            degreeReceived: '',
            major: ''
        })
    }
}

/**
 * Remove the last education entry, but leave at least one behind
 */
function removeEducation() {
    if (form.education.length > 1) {
        form.education.pop()
    }
}

// Form status
const loading = ref(false)

const handleSubmit = async () => {
    if (!signaturePad || signaturePad.isEmpty()) {
        notifyWarning('Please draw your signature before submitting.', 'Signature needed');
        return;
    }

    if (!form.passport) {
        notifyWarning('Please upload a valid passport image.', 'Passport needed');
        return;
    }

    form.applicantSignatureDataUrl = signaturePad.toDataURL('image/png');
    // Firebase Auth stores emails lowercase; store ours the same way so email lookups match after login
    form.email = form.email.trim().toLowerCase();
    loading.value = true;

    try {
        // 1. Upload files to Firebase Storage
        const uploadFile = async (file, path) => {
            const storageReference = storageRef(storage, path);  // Fixed: Properly get storage reference
            await uploadBytes(storageReference, file);
            return await getDownloadURL(storageReference);
        };

        // Prepare file paths
        const timestamp = Date.now();
        const passportPath = `applications/${timestamp}_${form.passport.name}`;
        const resumePath = form.resume ? `applications/${timestamp}_${form.resume.name}` : null;
        const reference1Path = form.reference1 ? `applications/${timestamp}_${form.reference1.name}` : null;
        const reference2Path = form.reference2 ? `applications/${timestamp}_${form.reference2.name}` : null;

        // Upload and get URLs
        const passportUrl = form.passport ? await uploadFile(form.passport, passportPath) : null;
        const resumeUrl = form.resume ? await uploadFile(form.resume, resumePath) : null;
        const reference1Url = form.reference1 ? await uploadFile(form.reference1, reference1Path) : null;
        const reference2Url = form.reference2 ? await uploadFile(form.reference2, reference2Path) : null;

        // 2. Store the URLs in Firestore. The account invite (or hiding it for a blocked/removed
        //    person) is handled server-side by the onApplicationCreated Cloud Function.
        const docRef = await addDoc(collection(db, 'applications'), {
            ...structuredClone(form),
            passport: passportUrl,
            resume: resumeUrl,
            reference1: reference1Url,
            reference2: reference2Url,
            companySelected: selectedCompany.value,
            status: 'Pending',
            submittedAt: serverTimestamp()
        });

        // Receipt for the confirmation page (applications aren't publicly readable)
        try {
            sessionStorage.setItem(`receipt:${docRef.id}`, JSON.stringify({
                firstName: form.firstName,
                lastName: form.lastName,
                email: form.email,
                companySelected: selectedCompany.value,
                positionapplying: form.positionapplying,
                submittedAt: new Date().toISOString(),
                applicantSignatureDataUrl: form.applicantSignatureDataUrl
            }));
        } catch (_e) {
            // Storage unavailable (private mode): the page still shows the confirmation ID
        }

        router.push({ path: '/submitted', query: { id: docRef.id } });

    } catch (error) {
        console.error('Error submitting application:', error);
        notifyError('Your application could not be submitted. Please try again.', 'Submission failed');
    }

    loading.value = false;
}
</script>


<style scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}

.progress-container {
    width: 100%;
    height: 8px;
    background: #e6e6e6;
    border-radius: 6px;
    margin-bottom: 1.5rem;
    overflow: hidden;
}

.progress-bar {
    height: 100%;
    background: #4361ee;
    transition: width 0.3s ease;
}


.container {
    width: 95%;
    max-width: 860px;
    margin: 2rem auto;
    padding: 2rem;
    background: white;
    border-radius: 10px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

h1 {
    text-align: center;
    color: #4361ee;
    font-size: 2rem;
    font-weight: 700;
    margin-bottom: 1.5rem;
}

.step-indicator {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 2rem;
    gap: 1.25rem;
}

.step-indicator div {
    width: 34px;
    height: 34px;
    border-radius: 50%;
    border: 2px solid #ccc;
    color: #ccc;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    background: white;
    transition: 0.3s;
}

.step-indicator .active {
    background: #4361ee;
    color: white;
    border-color: #4361ee;
}

.step-indicator .completed {
    background: #4cc9f0;
    color: white;
    border-color: #4cc9f0;
}

h2 {
    color: #3a0ca3;
    font-size: 1.25rem;
    font-weight: 600;
    margin-bottom: 1.25rem;
    border-bottom: 2px solid #e1e4e8;
    padding-bottom: 0.5rem;
}

.form-step {
    animation: fadeIn 0.4s ease;
}

@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(10px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

/* Default (desktop and tablet) */
input,
select,
textarea {
    width: 100%;
    padding: 0.75rem 1rem;
    margin-bottom: 1rem;
    border: 1px solid #dcdcdc;
    border-radius: 8px;
    font-size: 1rem;
    transition: border 0.3s;
    min-height: 44px;
    box-sizing: border-box;
    /* Make sure padding doesn't break size */
}

/* Flex Row (Desktop) */
.form-row {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
}

/* Flex children - Desktop */
.form-row>* {
    flex: 1 1 calc(33.333% - 1rem);
    /* 3 columns nicely spaced */
    min-width: 200px;
}

/* Mobile Responsive */
@media (max-width: 768px) {
    .form-row {
        flex-direction: column;
    }

    .form-row>* {
        flex: 1 1 100%;
        min-width: 0;
        /* Allow full shrink */
    }

    input,
    select,
    textarea {
        font-size: 0.95rem;
        padding: 0.6rem 0.9rem;
        min-height: 40px;
        margin-bottom: 0.9rem;
    }
}


.form-navigation {
    display: flex;
    justify-content: flex-end;
    margin-top: 2rem;
    gap: 1rem;
}

button {
    background-color: #4361ee;
    color: white;
    border: none;
    padding: 0.75rem 2rem;
    border-radius: 6px;
    font-size: 1rem;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.3s ease;
}

button:hover {
    background-color: #3a0ca3;
}

button:disabled {
    background-color: #cccccc;
    cursor: not-allowed;
}

button.btn-prev {
    background-color: #f1f1f1;
    color: #333;
}

button.btn-prev:hover {
    background-color: #ddd;
}

/* Mobile Responsive */
@media (max-width: 768px) {
    .form-row {
        flex-direction: column;
    }

    .form-navigation {
        flex-direction: column;
        align-items: stretch;
    }

    button {
        width: 100%;
    }
}


.company-logos {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 2rem;
    margin-top: 2rem;
}

.company-card {
    width: 200px;
    padding: 1rem;
    border-radius: 10px;
    background: #ffffff;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    text-align: center;
    cursor: pointer;
    transition: all 0.3s ease;
}

.company-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.12);
}

.company-card img {
    width: 100%;
    height: auto;
    margin-bottom: 1rem;
}

.company-card p {
    font-weight: 600;
    color: #333;
    font-size: 1.1rem;
}

/* Mobile */
@media (max-width: 768px) {
    .company-logos {
        flex-direction: column;
        align-items: center;
    }
}

.back-to-selection {
    margin-bottom: 1.5rem;
    text-align: left;
}

.btn-back {
    background-color: #e0ebff;
    /* light blue background */
    color: #4361ee;
    /* main app blue text */
    border: 1px solid #4361ee;
    /* main app blue border */
    padding: 0.6rem 1.5rem;
    border-radius: 8px;
    font-weight: 600;
    font-size: 1rem;
    cursor: pointer;
    transition: background-color 0.3s, color 0.3s, border-color 0.3s;
    margin-bottom: 1.5rem;
}

.btn-back:hover {
    background-color: #d0dbfc;
    /* slightly deeper blue on hover */
    color: #3a0ca3;
    /* darker theme blue on hover */
    border-color: #3a0ca3;
}


.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(2px);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.modal-content {
    background: white;
    padding: 2rem;
    border-radius: 12px;
    width: 90%;
    max-width: 400px;
    text-align: center;
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2);
    animation: fadeInModal 0.3s ease;
}

@keyframes fadeInModal {
    from {
        opacity: 0;
        transform: scale(0.9);
    }

    to {
        opacity: 1;
        transform: scale(1);
    }
}

.modal-actions {
    display: flex;
    justify-content: space-around;
    margin-top: 1.5rem;
}

.btn-cancel,
.btn-confirm {
    padding: 0.75rem 1.5rem;
    border: none;
    border-radius: 8px;
    font-size: 1rem;
    font-weight: 600;
    cursor: pointer;
    transition: background-color 0.3s;
}

.btn-cancel {
    background-color: #f1f1f1;
    color: #333;
}

.btn-cancel:hover {
    background-color: #ddd;
}

.btn-confirm {
    background-color: #4361ee;
    color: white;
}

.btn-confirm:hover {
    background-color: #3a0ca3;
}


.education-entry {
    background: #f8f9ff;
    padding: 1rem;
    border-radius: 8px;
    margin-bottom: 1.5rem;
    box-shadow: 0 2px 8px rgba(67, 97, 238, 0.08);
}

.add-education,
.remove-education {
    text-align: right;
    margin-top: 0.5rem;
}

.icon-btn {
    background-color: #4361ee;
    color: white;
    border: none;
    padding: 0.4rem 0.7rem;
    margin: 0 0.5rem;
    font-size: 1.2rem;
    border-radius: 6px;
    cursor: pointer;
    transition: background 0.3s ease;
}

.icon-btn:disabled {
    background-color: #cccccc;
    cursor: not-allowed;
}

.icon-btn:hover:not(:disabled) {
    background-color: #3a0ca3;
}

.education-actions {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 1rem;
}

.btn-add:hover {
    background-color: #4361ee;
}

.btn-remove {
    background-color: #f44336;
}

.btn-remove:hover {
    background-color: #d32f2f;
}

.entry-divider {
    margin-top: 1.5rem;
    border-top: 1px solid #dcdcdc;
}


/* --- Education Section Polishing --- */

/* Optional: Add description text styling */
.section-description {
    font-size: 0.95rem;
    color: #64748b;
    /* Slightly muted text */
    margin-top: -0.75rem;
    /* Pull closer to H2 */
    margin-bottom: 1.5rem;
}

/* Add some padding/background to the section content */
.education-section-content {
    background-color: #f8f9fc;
    /* Very light background */
    padding: 1.5rem;
    border-radius: 8px;
    margin-bottom: 1.5rem;
    /* Space before divider */
    border: 1px solid #eef0f6;
    /* Subtle border */
}

/* Table container for responsiveness */
.education-table-container {
    overflow-x: auto;
    /* Enable horizontal scroll on small screens */
    margin-bottom: 1.25rem;
    /* Space below table */
}

/* Polished table styles */
.education-table {
    width: 100%;
    min-width: 600px;
    /* Ensure minimum width for better layout before scroll */
    border-collapse: collapse;
    border-spacing: 0;
}

.education-table th,
.education-table td {
    padding: 0.8rem 1rem;
    /* Comfortable padding */
    text-align: left;
    vertical-align: top;
    /* Align content to the top */
    border-bottom: 1px solid #e2e8f0;
    /* Lighter row separator */
}

.education-table th {
    background-color: #f1f5f9;
    /* Light grey header */
    font-weight: 600;
    font-size: 0.9rem;
    color: #334155;
    white-space: nowrap;
    /* Prevent header text wrapping */
    border-bottom-width: 2px;
    /* Thicker bottom border for header */
    border-color: #cbd5e1;
}

/* Style for inputs within the table */
.education-table td input[type="text"] {
    width: 100%;
    padding: 0.6rem 0.8rem;
    /* Slightly smaller padding */
    border: 1px solid #d1d5db;
    border-radius: 6px;
    /* Slightly smaller radius */
    font-size: 0.95rem;
    margin-bottom: 0;
    /* Remove default margin */
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.education-table td input[type="text"]:focus {
    outline: none;
    border-color: #4361ee;
    box-shadow: 0 0 0 2px rgba(67, 97, 238, 0.2);
    /* Use existing focus style */
}

/* Style for table rows (optional: hover effect) */
.education-entry-row:hover {
    background-color: #ffffff;
    /* Highlight row on hover */
}

/* Polished action buttons */
.education-actions {
    display: flex;
    justify-content: flex-end;
    /* Align buttons to the right */
    gap: 0.75rem;
    /* Space between buttons */
    padding-top: 0.5rem;
    /* Add some space above buttons */
}

/* General icon button adjustments */
.icon-btn {
    display: inline-flex;
    /* Align icon and text */
    align-items: center;
    gap: 0.5rem;
    /* Space between icon and text */
    padding: 0.6rem 1.2rem;
    /* Adjusted padding */
    font-size: 0.9rem;
    /* Slightly smaller font */
    font-weight: 500;
    /* Normal weight */
    border-radius: 6px;
    border: 1px solid transparent;
    /* Base border */
    cursor: pointer;
    transition: background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease;
}

.icon-btn svg {
    width: 16px;
    /* Explicit size */
    height: 16px;
}

/* Specific Add Button Style */
.btn-add-edu {
    background-color: #e0f2fe;
    /* Light blue background */
    color: #0ea5e9;
    /* Blue text */
    border-color: #bae6fd;
    /* Lighter blue border */
}

.btn-add-edu:hover:not(:disabled) {
    background-color: #bae6fd;
    color: #0284c7;
    border-color: #7dd3fc;
}

/* Specific Remove Button Style */
.btn-remove-edu {
    background-color: #fee2e2;
    /* Light red background */
    color: #ef4444;
    /* Red text */
    border-color: #fecaca;
    /* Lighter red border */
}

.btn-remove-edu:hover:not(:disabled) {
    background-color: #fecaca;
    color: #dc2626;
    border-color: #fca5a5;
}

/* Disabled state for icon buttons */
.icon-btn:disabled {
    background-color: #f1f5f9 !important;
    /* Use !important if needed to override base button styles */
    color: #94a3b8 !important;
    border-color: #e2e8f0 !important;
    cursor: not-allowed;
}

/* Styling for the 'Other Training' textarea */
.training-textarea {
    /* Inherits general textarea styles, add specifics if needed */
    min-height: 100px;
    /* Slightly shorter */
}

.btn-clear {
    background: #f44336;
    color: white;
    padding: 0.5rem 1rem;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    font-weight: 600;
    font-size: 0.9rem;
}

.btn-clear:hover {
    background: #d32f2f;
}

.signature-date {
    margin-top: 1.5rem;
}

.signature-buttons {
    margin-top: 0.5rem;
}

.signature-canvas {
    width: 400px;
    height: 150px;
    border: 1px solid #ccc;
    border-radius: 8px;
}

.checkbox-group {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    margin-top: 1rem;
}

.checkbox-item {
    display: flex;
    align-items: flex-start;
    gap: 0.75rem;
    font-size: 0.95rem;
    color: #333;
    line-height: 1.4;
}

.checkbox-item input[type="checkbox"] {
    width: 24px;
    height: 24px;
    margin-top: 3px;
    accent-color: #3498db;
    cursor: pointer;
}

.checkbox-item span {
    flex: 1;
}

/* File upload styles */

.file-upload {
    margin-bottom: 1.5rem;
    padding: 1rem;
    background-color: #f9fafb;
    border: 2px dashed #d1d5db;
    border-radius: 8px;
    text-align: center;
    transition: background-color 0.3s, border-color 0.3s;
    position: relative;
}

.file-upload:hover {
    background-color: #e5e7eb;
    border-color: #6366f1;
}

.file-upload-label {
    display: block;
    font-size: 1rem;
    font-weight: bold;
    color: #374151;
    margin-bottom: 0.5rem;
}

.file-input {
    width: 100%;
    opacity: 0;
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    cursor: pointer;
}

.file-name {
    margin-top: 0.5rem;
    font-size: 0.875rem;
    color: #4b5563;
}

.error-text {
    color: #b91c1c;
    font-size: 0.875rem;
    margin-top: 0.5rem;
}

.file-upload::after {
    content: 'Browse';
    display: inline-block;
    padding: 0.5rem 1rem;
    background-color: #6366f1;
    color: white;
    border-radius: 5px;
    margin-top: 0.5rem;
    cursor: pointer;
    font-size: 0.875rem;
}

.file-upload:hover::after {
    background-color: #4f46e5;
}

.loading-spinner {
    display: inline-block;
    margin-left: 0.5rem;
    color: #4f46e5;
    font-weight: bold;
    font-size: 0.875rem;
}

.loading-spinner::after {
    content: '...';
    animation: ellipsis 1s infinite;
}

@keyframes ellipsis {
    0% {
        content: '';
    }

    33% {
        content: '.';
    }

    66% {
        content: '..';
    }

    100% {
        content: '...';
    }
}

.file-upload.disabled {
    opacity: 0.6;
    pointer-events: none;
}

/* 1) Make THIS step a containing block for absolutely‑positioned children */
.upload-step {
    position: relative;
    /* key line */
}

/* 2) Overlay that sits on top of the step only */
.upload-overlay.local {
    position: absolute;
    /* absolute, not fixed */
    inset: 0;
    /* top:0 right:0 bottom:0 left:0 */
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: rgba(255, 255, 255, 0.75);
    /* translucent white */
    backdrop-filter: blur(2px);
    /* optional glass‑blur */
    z-index: 20;
    /* higher than dashed box */
    border-radius: 8px;
    /* match the step’s rounded corners */
    pointer-events: none;
    /* so clicks don’t interfere */
}

/* 3) Re‑use your spinner from earlier (or any you like) */
.spinner {
    width: 48px;
    height: 48px;
    border: 6px solid #d1d5db;
    border-top-color: #6366f1;
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin-bottom: 0.75rem;
}

@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}

.upload-overlay.local p {
    font-weight: 600;
    color: #374151;
}

.ssn-wrapper {
    position: relative;
}

.ssn-input {
    width: 100%;
    padding: 0.5rem 3rem 0.5rem 0.75rem;
    /* pr = 3rem to make room for the button */
    border: 1px solid #ccc;
    border-radius: 0.375rem;
    font-size: 1rem;
    transition: border-color .2s;
}

.ssn-input:focus {
    outline: none;
    border-color: #3b82f6;
    box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.3);
}

.ssn-toggle {
    position: absolute;
    top: 50%;
    right: 0.5rem;
    transform: translateY(-50%);
    background: none;
    border: none;
    padding: 0.25rem 0.5rem;
    font-size: 0.875rem;
    color: #6b7280;
    cursor: pointer;
    border-radius: 0.25rem;
    transition: background .2s, color .2s;
}

.ssn-toggle:hover {
    background: #f3f4f6;
    color: #374151;
}

.ssn-toggle:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.5);
}
</style>